import cn from 'classnames';

import { dataTableStyles } from '@creditflowresearch/uilib/Table/DataTable';
import { ExpandableTable } from '@creditflowresearch/uilib/Table/ExpandableTable';
import { IColumn } from '@creditflowresearch/uilib/Table/DataTable/interfaces/Column';
import { DEFAULT_EMPTY_MESSAGE } from '@framework/ui/Molecules/Tables/constants';
import Paginator from '@creditflowresearch/uilib/Paginator';
import { useArticlesContext } from '@/creditflowresearch/application/ArticlesAndStats/Articles/CreditFlowArticlesContext';
import ArticleExpandedData from './ArticleExpandedData';

import styles from './articles.module.scss';
import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

interface IArticlesTableProps {
  columns: IColumn[],
}

const ArticlesTable = ({ columns }: IArticlesTableProps) => {
  const {
    articlesData: {
      collection,
      isFetching,
      page,
      perPage,
      totalCount,
      paginate,
    },
    isExpanded,
  } = useArticlesContext();

  return (
    <>
      <ExpandableTable
        dataTest="articlesDataTable"
        columns={ columns }
        collection={ collection }
        className={ cn(dataTableStyles.isHoverable, styles.articlesTable) }
        isFetching={ isFetching }
        emptyCollectionMessage={ isFetching ? '' : DEFAULT_EMPTY_MESSAGE }
        expandableRowContent={ ArticleExpandedData }
        isRowsExpanded={ isExpanded }
        expandCollapseOnRowClick={ false }
      />
      <Paginator
        className={ spacesStyles.pl }
        dataTest="articlesDataTablePagination"
        page={ page }
        perPage={ perPage }
        totalCount={ totalCount }
        isItemsPerPageVisible={ false }
        onPageChange={ ({ selected }) => paginate(selected) }
      />
    </>
  );
};

export default ArticlesTable;
